  <mat-chip-set>
    @for (element of filtersList; track element) {
    @let label = getLabel(element.id);
    <mat-chip-row (click)="openDialogFilter(element.id)" class="filter-chip" [title]="getFullTitleFilter(element.id)">
      {{element.label + (label ? label: '')}}
      @if(label){
        <mat-icon matChipRemove (click)="clearFilter($event, element.id)">cancel</mat-icon>
      }
    </mat-chip-row>
    }
  </mat-chip-set>

<bt-loader [loaderId]="loaderId">
  @if(styleDetails.schema){
  <ng-container>
    <div class="flex center margin-bottom">
      <div class="flex-0">
        <button class="icon-button back-button margin-right-x-small" (click)="onBack()">
          <i class="fa fa-chevron-left"></i>
        </button>
      </div>
      <div class="flex-1">
        <h4>{{styleDetails.schema.style.fullName}}</h4>
      </div>
    </div>
    <div class="flex" [id]="mainContainerElId">
      <div class="flex-1 margin-right">
        @for(item of styleDetails.schema.detailsRows; track item){
        <div class="card selectable flex center margin-bottom hover row-card"
          [ngClass]="{'active': styleDetails.activeShot && styleDetails.activeShot.colorId === item.colorId && styleDetails.activeShot.sizeGroupId === item.sizeGroupId}"
          inViewport (inViewportAction)="inViewportAction($event, item)"
          (click)="setActiveShot(item, item.shots ? item.shots[0] : null)"
          [@opacityAnimation]="item.isVisible ? 'show' : 'hide'">
          @if(item.isVisible){
          <ng-container>
            <div class="flex-0 margin-right">
              <bt-menu [show]="item.showMenu" (hidden)="item.showMenu = false" (showed)="item.showMenu = true">
                <div class="menu-item" (click)="onTemplateInfo(item)">
                  <i class="fa fa-info"></i>View template details
                </div>
                <div class="menu-item warning" (click)="onReshootRow(item)">
                  <i class="fa fa-trash"></i>Reshoot this row
                </div>
              </bt-menu>
            </div>
            <div class="flex-1 margin-right">
              <div class="padding-bottom-x-small"><b>Color</b>: {{item.fullName}}</div>
              <div class="padding-bottom-x-small">
                <b>Size group</b>: {{item.sizeGroupName || '- All -'}}
              </div>
              <div class="padding-bottom-x-small"><b>Status</b>: {{item.photoSessionStatus}}</div>
              <div class="padding-bottom-x-small"><b>Shots</b>: {{item.approvedShots}} of {{item.totalShots}}</div>
            </div>
            <div class="flex-0 nowrap flex">
              @for(t of item.shots; track t){
              <div class="flex vertical center margin-right"
                [title]="t.shotTypeName ? (t.shotTypeCode + ' - ' + t.shotTypeName) : t.shotTypeCode">
                <b class="padding-bottom-small">
                  {{t.shotTypeCode}}
                </b>
                <div class="thumbnail relative flex center justify-center" [ngClass]="{'empty': !t.imgPath}"
                  (click)="setActiveShot(item, t, $event)">
                  @if(t.imgPath){
                  <img [src]="t.imgPath">
                  }
                  @if(t.stateId === shotStatusEnum.Uploaded){
                  <div class="shot-icon">
                    <i class="fa fa-cloud-upload margin-small" title="Uploaded"></i>
                  </div>
                  }
                  @if(t.stateId === shotStatusEnum.Approved){
                  <div class="shot-icon approved">
                    <i class="fa fa-thumbs-up margin-small" title="Approved"></i>
                  </div>
                  }
                  @if(t.stateId === shotStatusEnum.Rejected){
                  <div class="shot-icon rejected">
                    <i class="fa fa-thumbs-down margin-small" title="Rejected"></i>
                  </div>
                  }
                </div>
              </div>
              }
            </div>
          </ng-container>
          }
        </div>
        }
      </div>
      <div class="flex-0">
        <div [id]="imgDetailsElId">
          <div class="card">
            @if(styleDetails.activeShot){
            <ng-container>
              <div class="thumbnail big flex center justify-center margin-bottom vertical"
                [ngClass]="{'empty': !styleDetails.activeShot.imgPath}">
                @if(styleDetails.activeShot.imgPath){
                  <div class="img-container">
                    <img
                      [preview]="styleDetails.activeShot.shotTypeName ? (styleDetails.activeShot.shotTypeCode + ' - ' + styleDetails.activeShot.shotTypeName) : styleDetails.activeShot.shotTypeCode"
                      [src]="styleDetails.activeShot.imgPath">
                  </div>
                }@else{
                  <div class="flex-1 flex center justify-center vertical">
                    <i class="fa fa-eye-slash no-image"></i>
                    <div class="margin-top">No image to view</div>
                  </div>
                }
              </div>
              <div class="margin-bottom-small flex justify-center">
                <b>{{styleDetails.activeShot.colorFullName}} |
                  {{styleDetails.activeShot.sizeGroupName || '- All size groups -'}}</b>
              </div>
              <div class="margin-bottom-small flex justify-center">
                <b>{{styleDetails.activeShot.shotTypeCode}}{{styleDetails.activeShot.shotTypeName ? (' - ' +
                  styleDetails.activeShot.shotTypeName) : ''}}</b>
              </div>
              <div class="margin-bottom flex justify-center">
                <b>{{styleDetails.activeShot.stateDescription}}</b>
              </div>
              <div class="flex buttons justify-between">
                <button (click)="changeImg(-1)">
                  <i class="fa fa-arrow-left"></i>Previous
                </button>
                <button [disabled]="styleDetails.activeShot.stateId !== shotStatusEnum.Uploaded" (click)="onReshoot()">
                  <i class="fa fa-refresh"></i>Reshoot
                </button>
                <button (click)="changeImg(1)">
                  <i class="fa fa-arrow-right"></i>Next
                </button>
              </div>
            </ng-container>
            }
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  }
</bt-loader>

@if(currentSidebarType === sidebarTypeEnum.customSidebar && !styleDetails.tmpRow){
  <bt-sidebar sidebarTitle="Reject shot" (exit)="onExitSidebar()">
    <div class="flex overflow vertical">
      <div class="flex-0 padding-top-large padding-bottom-large">
        Are you sure you want to <b>reject</b> selected shot?
      </div>
      <div class="flex-1 padding-bottom-large flex center justify-center sidebar-img-container">
        <img [src]="styleDetails.activeShot.imgPath">
      </div>
      <div class="flex-0">
        <div class="margin-bottom-small">
          <textarea rows="4" placeholder="Type comment..." class="full-width" cols="50"
            [(ngModel)]="actionComments"></textarea>
        </div>
      </div>
      <div class="flex-0">
        <button class="full-width warning" [loaderId]="sidebarLoaderId" (click)="reshoot()">
          <i class="fa fa-thumbs-down"></i>
          Reject shot
        </button>
      </div>
    </div>
  </bt-sidebar>
}

@if(currentSidebarType === sidebarTypeEnum.customSidebar && styleDetails.tmpRow){
  <bt-sidebar sidebarTitle="Template details" (exit)="onExitSidebar()">
    <bt-loader [loaderId]="sidebarLoaderId">
      @if(template){
        <div class="flex vertical full-height">
          <div class="flex-1 overflow padding-top-large padding-bottom-large padding-left-small padding-right-small">
            <div class="margin-bottom-small">Template name</div>
            <div class="card bold margin-bottom">{{template.templateName}}</div>
            <div class="margin-bottom-small">Brand</div>
            <div class="card bold margin-bottom">{{template.brandName}}</div>
            <div class="margin-bottom-small">Category</div>
            <div class="card bold margin-bottom">{{template.categoryName || '- All categories -'}}</div>
            <div class="margin-bottom-small">Styles</div>
            @if(template.styles.length){
              <div class="card margin-bottom">
                <b>{{template.styles[0].styleCode + ' - ' + template.styles[0].styleName}}</b>
                @if(template.styles.length > 1){
                  <span>
                    and <b>{{template.styles.length - 1}}</b> other{{template.styles.length > 2 ? 's' : '' }}
                  </span>
                }
              </div>
            }@else{
              <div class="card bold margin-bottom">- All styles -</div>
            }
            <div class="margin-bottom-small">Shot types</div>
            @for(type of template.shotTypes; track type){
            <div class="card bold margin-bottom-small">{{type.shotTypeCode}} - {{type.shotTypeName}}</div>
            }
          </div>
          <div class="flex-0">
            <button class="full-width">
              <i class="fa fa-external-link"></i>
              Go to templates list
            </button>
          </div>
        </div>
      }
    </bt-loader>
  </bt-sidebar>
}

@if(currentSidebarType === sidebarTypeEnum.deleteAction){
  <bt-sidebar sidebarTitle="Reshoot style row"
    (exit)="onExitSidebar()">
    <bt-loader [loaderId]="sidebarLoaderId">
      <div class="flex vertical full-height">
        @if(styleDetails.tmpRow){
          <div class="flex-1 flex center justify-center">
            <div>
              Are you sure you want to <b>reshoot</b> this style combination {{styleDetails.schema.style.fullName}} |
              {{styleDetails.tmpRow.fullName}} {{styleDetails.tmpRow.sizeGroupId ? (' - ' +
              styleDetails.tmpRow.sizeGroupName)
              : ''}}?
              <br><br>
              All style combination shots will be deleted.
            </div>
          </div>
        }
        <div class="flex-0">
          <button class="full-width warning" (click)="reshootRow()">
            <i class="fa fa-trash"></i>
            Reshoot style row
          </button>
        </div>
      </div>
    </bt-loader>
  </bt-sidebar>
}